import ImportBLFormController from './import.bl.form.controller.js';

export default {
    template: require('./import.bl.form.html'),
    controller: ImportBLFormController
};
